var React = require('react');

function PlayButton (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#e03116","fillRule":"evenodd"},[React.createElement("circle",{"cx":"19.24","cy":"19.24","fillOpacity":".25","r":"19.24","key":0}),React.createElement("path",{"d":"m22.7008968 13.7490718 6.8928248 10.6043458c.4454634.6853282.2510144 1.6020159-.4343138 2.0474793-.2400712.1560463-.5202532.2391034-.8065828.2391034h-13.7856495c-.8173814 0-1.48-.6626185-1.48-1.48 0-.2863295.0830572-.5665116.2391035-.8065827l6.8928247-10.6043458c.4454634-.6853283 1.3621511-.8797772 2.0474793-.4343138.1735496.1128072.3215066.2607642.4343138.4343138z","transform":"matrix(0 1 -1 0 40.7 -2.22)","key":1})]));
}

PlayButton.defaultProps = {"height":"39","viewBox":"0 0 39 39","width":"39"};

module.exports = PlayButton;

PlayButton.default = PlayButton;
